import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { getAll as getAllPosjete } from "../../services/statistikaClanka.service";
import clanakService from "../../services/clanak.service";
import { subDays, isAfter, parseISO } from "date-fns";
import "./NajposjecenijiClanci.css";

const colors = ["#AED9E0", "#B5EAD7", "#E6E6FA", "#D3D3D3", "#FFD1DC"];

const CustomTick = ({ x, y, payload }) => {
  const puniNaziv = payload.value || "";
  const prikazaniNaziv =
    puniNaziv.length > 15 ? puniNaziv.slice(0, 20) + "…" : puniNaziv;

  return (
    <g transform={`translate(${x},${y})`}>
      <title>{puniNaziv}</title>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fill="#666"
        transform="rotate(-30)"
        fontSize={13}
      >
        {prikazaniNaziv}
      </text>
    </g>
  );
};

const NajposjecenijiClanci = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: clanci } = await clanakService.getAll();
        const mapaClanci = {};
        clanci.forEach((clanak) => {
          mapaClanci[clanak.id] = clanak.naslov;
        });

        const { data: svePosjete } = await getAllPosjete();
        const sedamDanaUnazad = subDays(new Date(), 7);

        const posjeteZadnjih7Dana = svePosjete.filter((p) => {
          const datum = parseISO(p.vremenskaOznaka || p.vremenska_oznaka);
          return isAfter(datum, sedamDanaUnazad);
        });

        const brojac = {};
        posjeteZadnjih7Dana.forEach((posjeta) => {
          const clanakId = posjeta.clanakId;
          if (!brojac[clanakId]) brojac[clanakId] = 0;
          brojac[clanakId]++;
        });

        const rezultat = Object.entries(brojac)
          .map(([id, posjete], index) => ({
            naziv: mapaClanci[id] || `Članak ${id}`,
            posjete,
            fill: colors[index % colors.length],
          }))
          .sort((a, b) => b.posjete - a.posjete)
          .slice(0, 5);

        setData(rezultat);
      } catch (error) {}
    };

    fetchData();
  }, []);

  return (
    <div className="najposjeceniji-clanci-container">
      <h2 className="najposjeceniji-clanci-heading">
        Top 5 najposjećenijih članaka u zadnjih 7 dana
      </h2>
      {data.length === 0 ? (
        <div className="text-center">Nema podataka za prikaz.</div>
      ) : (
        <div className="chart-wrapper">
          <ResponsiveContainer width="100%" height={400}>
            <BarChart
              data={data}
              margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
            >
              <XAxis
                dataKey="naziv"
                tick={<CustomTick />}
                interval={0}
                height={100}
              />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="posjete" name="Broj posjeta">
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.fill} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default NajposjecenijiClanci;
